import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const CITIES = [
  "Whitby",
  "Oshawa",
  "Ajax",
  "Pickering",
  "Clarington",
  "Uxbridge",
  "Toronto",
  "Markham",
  "Vaughan",
  "Richmond Hill",
  "Mississauga",
  "Brampton",
];

export const TrustBar = () => {
  return (
    <section
      className="border-y border-zinc-200 bg-white"
      data-testid="trust-bar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 md:py-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex items-center gap-3 shrink-0">
          <MapPin className="w-4 h-4 text-orange-600" />
          <span className="overline">Serving</span>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm md:text-[15px] text-zinc-800">
          {CITIES.map((city, idx) => (
            <motion.span
              key={city}
              initial={{ opacity: 0, y: 6 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: idx * 0.03 }}
              className="flex items-center gap-6 font-semibold tracking-tight"
              data-testid={`trust-city-${city.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {city}
              {idx !== CITIES.length - 1 && (
                <span className="text-orange-600/60 hidden md:inline">·</span>
              )}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
};
